import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ConfigService } from '../settings/services/config.service';
import { UiConfig } from '../../generated/graphql';

type JustifyFlag = 'justifyAlerts' | 'justifyShifts';

@Injectable({
  providedIn: 'root',
})
export class JustifyGuard implements CanActivate {
  constructor(
    private config: ConfigService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const flag = route.data['justifyFlag'] as JustifyFlag;
    return this.config.loaded$.pipe(
      first(),
      map((config: UiConfig) => (config[flag] ? true : this.router.parseUrl('/guardias')))
    );
  }
}
